export default class PolicyCodingApi {
  constructor(client) {
    this.client = client;
    this.resourceUrl = "/policyCoding";
  }

  getDxExpanded(dxCodeRange) {
    return this.client.post(`${this.resourceUrl}/dxCodes/explode`, {
      dxCodeRange,
    });
  }

  getDxCollapsed(dxCodes) {
    return this.client.post(`${this.resourceUrl}/dxCodes/collapse`, {
      dxCodes,
    });
  }
}
